const avCountries = state => state.avCountries;

const activeCountryId = state => state.activeCountryId;

const activeCountryCurr = (state) => {
    if (state.avCountries)
        return state.avCountries.find(country => country.id === state.activeCountryId).currency
}

export default {
    avCountries,
    activeCountryId,
    activeCountryCurr
}
